module.exports = __webpack_public_path__ + "img/wj02.f3f6cc56.png";